import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var PuzzlePiece01 = function PuzzlePiece01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M7.5 4.5C7.5 3.1193 8.6193 2 10 2s2.5 1.1193 2.5 2.5V6h1c1.3978 0 2.0967 0 2.6481.2284a3 3 0 0 1 1.6235 1.6236C18 8.4033 18 9.1022 18 10.5h1.5c1.3807 0 2.5 1.1193 2.5 2.5s-1.1193 2.5-2.5 2.5H18v1.7c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C15.7202 22 14.8802 22 13.2 22h-.7v-1.75c0-1.2426-1.0074-2.25-2.25-2.25S8 19.0074 8 20.25V22H6.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 19.7202 2 18.8802 2 17.2v-1.7h1.5C4.8807 15.5 6 14.3807 6 13s-1.1193-2.5-2.5-2.5H2c0-1.3978 0-2.0967.2284-2.648a3 3 0 0 1 1.6235-1.6236C4.4034 6 5.1023 6 6.5 6h1z"
    })
  }));
};
export default PuzzlePiece01;